var TrackingEvent = /** @class */ (function () {
    function TrackingEvent(eventName) {
        this.callbacks = [];
        this.name = eventName;
    }
    TrackingEvent.prototype.registerCallback = function (callback) {
        this.callbacks.push(callback);
    };
    return TrackingEvent;
}());
var TrackingEventReactor = /** @class */ (function () {
    function TrackingEventReactor() {
        this.events = {};
    }
    /**
     * Registeres a new event for later use
     * @param eventName Name of event
     */
    TrackingEventReactor.prototype.registerEvent = function (eventName) {
        var event = new TrackingEvent(eventName);
        this.events[eventName] = event;
    };
    /**
     * Dispatches a given event to all listeners
     *
     * @param eventName Name of event
     * @param eventArgs Additional data passed to all listeners
     */
    TrackingEventReactor.prototype.dispatch = function (eventName, eventArgs) {
        if (!this.events[eventName]) {
            this.registerEvent(eventName);
        }
        this.events[eventName].callbacks.forEach(function (callback) {
            callback(eventArgs);
        });
        if (window.laravelDebug) {
            console.log("%cGlobal Event: ".concat(eventName, " (notified ").concat(this.events[eventName].callbacks.length, " listeners)"), 'background: #2edeac; color: #000;', eventArgs);
        }
    };
    /**
     * Listenes to a given event and runs callback if the event is dispatched
     *
     * @param eventName Name of event
     * @param callback Callback after event is dispatched
     */
    TrackingEventReactor.prototype.listen = function (eventName, callback) {
        if (!this.events[eventName]) {
            this.registerEvent(eventName);
        }
        this.events[eventName].registerCallback(callback);
    };
    /**
     * Unregister all event callbacks
     * Stops all listeners from receiving events
     */
    TrackingEventReactor.prototype.destroy = function () {
        var _this = this;
        var eventNames = Object.keys(this.events);
        eventNames.forEach(function (eventName) {
            _this.events[eventName].callbacks = [];
        });
    };
    return TrackingEventReactor;
}());
export default new TrackingEventReactor();
